export const TRANSPORTATION_STATUS_PARAM_NAME: string = 'transportation_status'
export const REF_TYPE_PARAM_NAME: string = 'ref_type'
